module.exports = __webpack_public_path__ + "media/01_普清480P.5966840b.mp4";